import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AdminStartDepotRow from './adminStartDepotRow';
import Helmet from 'react-helmet';

const AdminStartDepots = ({ setLoading, setError }) => {
  const [sortBy, setSortBy] = useState('idDesc');
  const [startDepots, setStartDepots] = useState([]);

  useEffect(() => {
    getStartDepots(null);
  }, []);

  function getStartDepots(newSortParam) {
    setLoading(true);
    apiCalls
      .getStartDepots({ sortBy: newSortParam || sortBy })
      .then((result) => {
        setStartDepots(result.data.startDepots);
        setLoading(false);
      })
      .catch((errors) => {
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(errors));
      });
  }

  function setSortMethod(newSortBy) {
    let sortParam;

    switch (newSortBy) {
      case 'id':
      default:
        sortParam = sortBy === 'idAsc' ? 'idDesc' : 'idAsc';
    }

    setSortBy(sortParam);
    getStartDepots(sortParam);
  }
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.start.depots.title' })}</title>
      </Helmet>
      <h3>
        <FormattedMessage id={'admin.start.depots.title'} />
      </h3>

      <div className="m-b-3">
        <Link className="btn btn-default" to="/admin/startDepots/create">
          <FormattedMessage id={'admin.button.create'} />
        </Link>
      </div>

      <table className="table table-striped admin__table admin__table m-bottom-margin">
        <thead>
          <tr>
            <th onClick={() => setSortMethod('id')} className="sortable" scope="col">
              <FormattedMessage id={'admin.start.depots.table.id'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.start.depots.table.name'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.start.depots.table.address'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'admin.start.depots.table.actions'} />
            </th>
          </tr>
        </thead>
        <tbody>
          {startDepots.map((startDepot, index) => (
            <AdminStartDepotRow startDepot={startDepot} key={index} getStartDepots={getStartDepots} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

AdminStartDepots.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminStartDepots.defaultProps = {};

export default AdminStartDepots;
